// Packages
import { saveAs } from "file-saver"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import * as React from "react"

// Default Component
function Resources(props) {
  const { Book } = useStaticQuery(graphql`
    query {
      Book: file(relativePath: { regex: "/open-book/" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
    }
  `)
  return (
    <div className="bg-grey-3 container--padding py-[32px]">
      <div className="container--content gap-0 grid justify-items-center desktop:gap-x-0 desktop:grid-cols-[auto_auto] desktop:items-center">
        <GatsbyImage
          alt=""
          className="max-w-[292px]"
          image={Book.childImageSharp.gatsbyImageData}
        />
        {/* Text and Link Container */}
        <div className="flex flex-col gap-[32px] w-full desktop:flex-row">
          <div
            className="mb-0 text-center"
            dangerouslySetInnerHTML={{
              __html: props.copy,
            }}
          />
          {props.resource.fileName ? (
            <button
              className="button button--primary w-full desktop:w-fit"
              onClick={() =>
                saveAs(props.resource.externalLink, props.resource.text.text)
              }
            >
              {props.resource.text.text}
            </button>
          ) : (
            <a
              className="button button--primary w-full desktop:w-fit"
              href={props.resource.externalLink}
              target="_blank"
              rel="noreferrer"
            >
              {props.resource.text.text}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default Resources
